import React from 'react';

/**
 * @typedef {object} DialogWithoutFormWrapperProps
 * @property {React.ReactNode} children
 * @property {(data?: Object) => void | Promise<void>} [handleConfirm]
 */

/**
 * @param {DialogWithoutFormWrapperProps} props
 */
const DialogWithoutFormWrapper = props => {
  const { children } = props;

  return <>{children}</>;
};

export default DialogWithoutFormWrapper;
